import { Spinner } from "reactstrap";

const LoadingTable = () => {
  return (
    <div className="loading-spinner">
      <Spinner color="primary" type="grow" className="spinner" />
      <Spinner color="warning" type="grow" className="spinner" />
      <Spinner color="secondary" type="grow" className="spinner" />
      <Spinner color="info" type="grow" className="spinner" />
      <Spinner color="success" type="grow" className="spinner" />
    </div>
  );
};

export default LoadingTable;
